import {
  GET_APPOINTMENT,
  GET_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_CLEAR_DATA,
  GET_APPOINTMENT_ERROR,
  APPOINTMENTACTION_PATCH,
  APPOINTMENTACTION_PATCH_CLEAR_DATA,
  APPOINTMENTACTION_PATCH_ERROR,
  APPOINTMENTACTION_PATCH_SUCCESS,
  GET_APPOINTMENTACTION,
  GET_APPOINTMENTACTION_CLEAR_DATA,
  GET_APPOINTMENTACTION_ERROR,
  GET_APPOINTMENTACTION_SUCCESS,

} from "./actionTypes";

export const getAppointment = (appointment, history) => {
  return {
    type: GET_APPOINTMENT,
    payload: { appointment, history },
  };
};

export const getAppointmentSuccess = (success) => {
  return {
    type: GET_APPOINTMENT_SUCCESS,
    payload: success,
  };
};

export const getAppointmentError = (error) => {
  return {
    type: GET_APPOINTMENT_ERROR,
    payload: error,
  };
};

export const getAppointmentClearData = () => {
  return {
    type: GET_APPOINTMENT_CLEAR_DATA,
    payload: {},
  };
};

export const getAppointmentAction = (appointment, history) => {
  return {
    type: GET_APPOINTMENTACTION,
    payload: { appointment, history },
  };
};

export const getAppointmentActionSuccess = (success) => {
  return {
    type: GET_APPOINTMENTACTION_SUCCESS,
    payload: success,
  };
};

export const getAppointmentActionError = (error) => {
  return {
    type: GET_APPOINTMENTACTION_ERROR,
    payload: error,
  };
};

export const getAppointmentActionClearData = () => {
  return {
    type: GET_APPOINTMENTACTION_CLEAR_DATA,
    payload: {},
  };
};

export const appointmentActionPatch = (appointmentActionBody, appointmentId) => {
  return {
    type: APPOINTMENTACTION_PATCH,
    payload: { appointmentActionBody, appointmentId },
  };
};

export const appointmentActionPatchSuccess = (success) => {
  return {
    type: APPOINTMENTACTION_PATCH_SUCCESS,
    payload: success,
  };
};

export const appointmentActionPatchError = (error) => {
  return {
    type: APPOINTMENTACTION_PATCH_ERROR,
    payload: error,
  };
};

export const appointmentActionPatchClearData = () => {
  return {
    type: APPOINTMENTACTION_PATCH_CLEAR_DATA,
    payload: {},
  };
};

